import { create } from 'zustand';

import { persist } from 'zustand/middleware';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: { id: string; email: string; displayName: string | null } | null;
  defaultOrgId: string | null;
  defaultRole: string | null;

  setSession: (s: {
    accessToken: string;
    refreshToken: string;
    user: { id: string; email: string; displayName: string | null };
    defaultOrgId: string;
    defaultRole: string;
  }) => void;
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      defaultOrgId: null,
      defaultRole: null,

      setSession(s) {
        set({
          accessToken: s.accessToken,
          refreshToken: s.refreshToken,
          user: s.user,
          defaultOrgId: s.defaultOrgId,
          defaultRole: s.defaultRole,
        });
      },

      clearSession() {
        set({
          accessToken: null,
          refreshToken: null,
          user: null,
          defaultOrgId: null,
          defaultRole: null,
        });
      },
    }),
    { name: 'forge-builder-auth' },
  ),
);
